const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input has-text-right pr-3"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							disabled
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input has-text-right pr-3"
									{~D:Record.Macro.ControlAttr~}
									type="text"
									tabindex="-1"
									readonly
									disabled
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType Text {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input has-text-right pr-3"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						type="text"
						tabindex="-1"
						readonly
						disabled
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<p class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input has-text-right pr-3"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							disabled
							value=""
						/>
					</p>
					{~UnitsAddon:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<input
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input has-text-right pr-3"
									{~D:Record.Macro.ControlAttr~}
									tabindex="-1"
									readonly
									disabled
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<input
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="input has-text-right pr-3"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						type="text"
						tabindex="-1"
						readonly
						disabled
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right mb-0">
					<div class="control is-expanded">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<input
							id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static has-text-right"
							{~D:Record.Macro.ControlAttr~}
							type="text"
							tabindex="-1"
							readonly
							value=""
						/>
					</div>
					{~UnitsAddonPrint:Record~}
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<div class="control is-expanded">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value="">
								<div
									id="INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static has-text-right"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
							{~UnitsAddonPrint:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PreciseNumberReadOnly',
			DefaultInputExtensions: [ 'Pict-Input-PreciseNumber' ],
			Template: /*HTML-Partial*/`
			<!-- DataType PreciseNumberReadOnly {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<div class="control is-expanded">
					<input
						id="PRECISE-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PreciseNumberReadOnly',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<div
						id="TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						class="input is-static has-text-right"
					></div>
				</div>
				{~UnitsAddonPrint:Record~}
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
